// extracted by mini-css-extract-plugin
export var aggregationCell = "_20-h";
export var aggregationRow = "_20-g";
export var borderlessSpinnerContainer = "_20-2";
export var closeIcon = "_20-9";
export var expandIcon = "_20-a";
export var expanded = "_20-b";
export var filterDropdown = "_20-c";
export var filterDropdownDivider = "_20-7";
export var filterDropdownHeader = "_20-f";
export var filterDropdownItem = "_20-e";
export var filterDropdownModal = "_20-d _20-c";
export var filterItem = "_20-6";
export var normalCellWithAdjustableBorder = "_20-8";
export var pinButtonContainer = "_20-i";
export var pinIcon = "_20-j";
export var pinIconActive = "_20-k";
export var spinner = "_20-0";
export var spinnerContainer = "_20-1";
export var tableContainer = "_20-3";
export var tableContentInner = "_20-5";
export var tableContentWrapper = "_20-4";
export var viewButtonContainer = "_20-l";